const collator = new Intl.Collator('es', {
  numeric: true,
  sensitivity: 'base',
});

const slashCodePattern = /^(\d+)\/(\d+)$/;
const integerPattern = /^\d+$/;
const isoDatePattern =
  /^\d{4}-\d{2}-\d{2}(?:[T\s]\d{2}:\d{2}(?::\d{2}(?:\.\d{1,3})?)?(?:Z|[+-]\d{2}:\d{2})?)?$/;

function toComparableNumber(value: unknown): number | null {
  if (typeof value === 'number') {
    return Number.isNaN(value) ? null : value;
  }
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!integerPattern.test(trimmed)) {
      return null;
    }
    const parsed = Number(trimmed);
    return Number.isNaN(parsed) ? null : parsed;
  }
  return null;
}

function toComparableDateEpoch(value: unknown): number | null {
  if (typeof value !== 'string') {
    return null;
  }
  const trimmed = value.trim();
  if (!isoDatePattern.test(trimmed)) {
    return null;
  }
  const epoch = Date.parse(trimmed);
  return Number.isNaN(epoch) ? null : epoch;
}

function compareStringNaturally(a: string, b: string): number {
  const aTrim = a.trim();
  const bTrim = b.trim();

  const slashA = slashCodePattern.exec(aTrim);
  const slashB = slashCodePattern.exec(bTrim);
  if (slashA != null && slashB != null) {
    const aLeft = Number(slashA[1]);
    const bLeft = Number(slashB[1]);
    if (aLeft !== bLeft) {
      return aLeft - bLeft;
    }
    const aRight = Number(slashA[2]);
    const bRight = Number(slashB[2]);
    return aRight - bRight;
  }

  return collator.compare(aTrim, bTrim);
}

export function compareValuesNaturally(a: unknown, b: unknown): number {
  if (a == null && b == null) {
    return 0;
  }
  if (a == null) {
    return 1;
  }
  if (b == null) {
    return -1;
  }

  const aDate = toComparableDateEpoch(a);
  const bDate = toComparableDateEpoch(b);
  if (aDate != null && bDate != null) {
    return aDate - bDate;
  }

  const aNum = toComparableNumber(a);
  const bNum = toComparableNumber(b);
  if (aNum != null && bNum != null) {
    return aNum - bNum;
  }

  return compareStringNaturally(String(a), String(b));
}
